import React from 'react';
import { FaFacebookF, FaYoutube } from "react-icons/fa";
import { FaXTwitter, FaLinkedinIn } from "react-icons/fa6";
import { LuInstagram } from "react-icons/lu";
import { FaLink } from "react-icons/fa6";
import { HiOutlineMail } from "react-icons/hi";
import { IoMdArrowRoundForward } from "react-icons/io";
import FooterLogo from '../Assets/Images/INNOVATIONS_AHEAD-removebg-preview.png';

const Footer = () => {
  return (
    <footer className="bg-[#111212] text-white px-6 pt-10 pb-6">

      {/* Footer Info Grid */}
      <div className="grid grid-cols-2 md:grid-cols-12 gap-6">

        {/* Logo & Address */}
        <div className="col-span-2 md:col-span-3 flex flex-col justify-between text-sm text-white h-full">
          <div>
            <img src={FooterLogo} alt="VST Logo" className="h-10 object-contain mb-4" />
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-2">Visit Us</h3>
            <p className="font-medium leading-relaxed">
              No-68A, Kuruvikaran Salai 3rd Street,<br />
              Anna Nagar,<br />
              Madurai - 625020
            </p>
          </div>
        </div>

        {/* Quick Links */}
        <div className="col-span-1 md:col-span-3 text-white">
          <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
            <FaLink className="text-white" />
            Quick Links
          </h3>
          <div className="flex flex-col gap-2 text-gray-300">
            {[
              { name: "About Us", link: "/aboutUs" },
              { name: "Services", link: "/services" },
              { name: "Products", link: "/products" },
              { name: "Careers", link: "/careers" },
              { name: "Corporate Training", link: "/corporateTraining" },
              { name: "Contact Us", link: "/contactUs" },
              { name: "Testimonials", link: "/testimonials" },
              { name: "Faq", link: "/faq" },
            ].map((item, i) => (
              <a
                key={i}
                href={item.link}
                className="group flex items-center justify-between font-medium hover:text-white hover:underline transition-all"
              >
                <span className='font-medium'>{item.name}</span>
                {/* Arrow - hidden until hover */}
                <IoMdArrowRoundForward size={25} className="opacity-0 group-hover:opacity-100 translate-x-1 transition-all duration-300" />
              </a>
            ))}
          </div>
        </div>

        {/* Services */}
        <div className="col-span-1 md:col-span-3 text-white">
          <h3 className="text-lg font-semibold mb-4">Services</h3>
          <ul className="space-y-2 text-gray-300">
            <li className='font-medium'>Software Development</li>
            <li className='font-medium'>Web Development</li>
            <li className='font-medium'>Mobile App Development</li>
            <li className='font-medium'>Internship</li>
            <li className='font-medium'>Digital Marketing</li>
            <li className='font-medium'>IT Consulting</li>
            <li className='font-medium'>Training And Consulting</li>
          </ul>
        </div>

        {/* Technology */}
        <div className="col-span-2 md:col-span-3 text-white">
          <h3 className="text-lg font-semibold mb-4">Technology</h3>
          <ul className="space-y-2 text-gray-300">
            <li className='font-medium'>Front-End</li>
            <li className='font-medium'>Back-End</li>
            <li className='font-medium'>Cross-Platform</li>
            <li className='font-medium'>Full Stack</li>
            <li className='font-medium'>DevOps & ML</li>
          </ul>
        </div>

      </div>

      <div className="w-full border-t border-gray-600 my-6"></div>


      {/* Contact & Social Section */}
      <div className="md:flex justify-between items-start gap-4 mt-10">

        {/* Contact Info */}
        <div className="text-sm text-white space-y-2">
          <p>
            <span className="font-semibold text-gray-400">Business Enquiry:</span>{" "}
            <a href="tel:+916374045002" className="font-semibold text-white hover:underline">
              +91 637 404 5002
            </a>
          </p>
          <p>
            <span className="font-semibold text-gray-400">For Job:</span>{" "}
            <a href="tel:+919092941177" className="font-semibold text-white hover:underline">
              +91 909 294 1177
            </a>
          </p>
        </div>


        {/* Social Icons + Email */}
        <div className="flex flex-col items-start md:items-end gap-2 text-xl mt-6 md:mt-0">

          {/* Social Icons */}
          <div className="flex gap-3">
            <a
              href="https://www.facebook.com/profile.php?id=61578859581103"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform duration-300 hover:-translate-y-2 hover:scale-125"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://x.com/Viveka_SofTek"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform duration-300 hover:-translate-y-2 hover:scale-125"
            >
              <FaXTwitter />
            </a>
            <a
              href="https://www.youtube.com/@VIVEKASOFTEK-e3r"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform duration-300 hover:-translate-y-2 hover:scale-125"
            >
              <FaYoutube />
            </a>
            <a
              href="https://www.instagram.com/vivekasoftek_official"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform duration-300 hover:-translate-y-2 hover:scale-125"
            >
              <LuInstagram />
            </a>
            <a
              href="https://www.linkedin.com/in/viveka-softek-b16373376/"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-transform duration-300 hover:-translate-y-2 hover:scale-125"
            >
              <FaLinkedinIn />
            </a>
          </div>

          {/* Email */}
          <a
            href="mailto:info@vivekasoftek.com"
            className="text-sm text-white mt-2 flex font-medium items-center gap-2 hover:underline"
            target="_blank"
            rel="noopener noreferrer"
          >
            <HiOutlineMail />
            info@vivekasoftek.com
          </a>
        </div>
      </div>

      <div className="w-full border-t border-gray-600 my-3"></div>

      <div className="text-center text-sm font-medium text-gray-400">
        © Copyright {new Date().getFullYear()} by Vivekasoftek
      </div>


    </footer>
  );
};

export default Footer;
